module.exports = __webpack_public_path__ + "fonts/LatoLatin-Semibold.008763c.woff2";